export const HTTPS_REQUIRED_URL_ERROR = 'URL must begin with https://';

export function validateHttpsUrl(value: string): string | undefined {
    if (!value) {
        return undefined;
    }

    return value.trim().toLowerCase().startsWith('https://') ? undefined : HTTPS_REQUIRED_URL_ERROR;
}
